"use client";

import { Footer, Nav } from "@/components/bnp-ui";
import CookiePolicy from "@/components/pages/auth/sign-up/CookiePolicy";

export function CookiePolicyView() {
  return (
    <div>
      <Nav />
      <div className="p-4 lg:p-8">
        <h1 className="text-2xl text-main-900 font-semibold mb-8">
          Cookie Policy
        </h1>
        <CookiePolicy />
      </div>
      <Footer />
    </div>
  );
}
